<div class="body" id="topheader">
  <nav class="navbar">
    <div class="container-fluid">
      <div class="navbar-header">
        <a class="imglogo" href="https://ecell.in" target="_blank"
          ><img src="assets/images/logoblk.png" alt="E-Cell"
        /></a>
        <div
          [className]="isOpen ? 'ham' : 'ham openham'"
          (click)="toggleDisplay($event)"
        >
          <!-- <i class="fa-solid fa-bars fa-2xl"></i> -->
          <span [className]="isOpen ? 'top' : 'top-open'"></span>
          <span [className]="isOpen ? 'mid' : 'mid-open'"></span>
          <span [className]="isOpen ? 'bottom' : 'bottom-open'"></span>
        </div>
      </div>
      <!-- <ul class="nav navbar-nav">

          </ul> -->
      <!-- <button>Toggle</button> -->
      <ul class="nav navbar-nav navbar-right switches extra">
        <!-- <li *ngFor="let navitem of navItems">
          <a href="#"
            >Home
            <div class="underline active"></div
          ></a>
        </li> -->
        <li *ngFor="let navItem of navItems" [routerLink]="[navItem.route]">
          <a
            >{{ navItem.name }}
            <div class="underline"></div
          ></a>
        </li>
        <!-- <li [routerLink]="['/tracks']">
          <a
            >Tracks
            <div class="underline"></div
          ></a>
        </li>
        <li [routerLink]="['/incentives']">
          <a
            >Incentives
            <div class="underline"></div
          ></a>
        </li>
        <li [routerLink]="['/sponsors']">
          <a
            >Sponsors
            <div class="underline"></div
          ></a>
        </li>
        <li [routerLink]="['/pastwin']">
          <a
            >Past Winners
            <div class="underline"></div
          ></a>
        </li>

        <li [routerLink]="['/contact']">
          <a
            >Contact
            <div class="underline"></div
          ></a>
        </li>
        <li [routerLink]="['/mediapresence']">
          <a
            >Media Presence
            <div class="underline"></div
          ></a>
        </li>
        -->
        <li>
          <a
            class="btn btn-lg inverse"
            (click)="register()"
            style="margin-bottom: 5px"
            >Login</a
          >
        </li>
        <!-- <li><a href="#"><span class="glyphicon glyphicon-user"></span> Sign Up</a></li>
            <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> Login</a></li> -->
      </ul>
      <ul
        class="nav navbar-nav navbar-right switches extra-2"
        [hidden]="isShow"
      >
        <!-- <li (click)="toggleDisplay($event)"><a [routerLink]="['/land']">Home2<div class="underline active"></div></a></li> -->
        <li
          (click)="toggleDisplay($event)"
          *ngFor="let navItem of navItems"
          [routerLink]="[navItem.route]"
        >
          <a
            >{{ navItem.name }}
            <div class="underline"></div
          ></a>
        </li>

        <li (click)="toggleDisplay($event)">
          <a class="btn btn-lg inverse" (click)="register()">Login</a>
        </li>
        <!-- <li><a href="#"><span class="glyphicon glyphicon-user"></span> Sign Up</a></li>
            <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> Login</a></li> -->
      </ul>
    </div>
  </nav>
</div>

<script>
  $("container-fluid .active").on("click", function () {
    $("container-fluid .navbar-nav").find("li.active").removeClass("active");
    $(this).parent("li").addClass("active");
  });
</script>
